// Tools: Helper functions used within actions.
import { normalizeBankregnr } from '../util/bankregnr';
import { actionTypes } from './types';

/* Request Headers */
export const getRequestHeaders = (bankregnr: string | null): { headers: { [key: string]: string } } => ({
    headers: {
        'X-BankRegNr': normalizeBankregnr(bankregnr) || '',
        'Content-Type': 'application/json',
        'X-Requested-By': 'salgspantlaan-js-client',
    },
});

export const getCalculatorRequestPath = (bankregnr: string | null, ...pathSegments: string[]): string =>
    `${actionTypes.RESOURCE_PATH}/calculator/${normalizeBankregnr(bankregnr) || bankregnr}/${pathSegments.join('/')}`;

/* Check Local */
export const isLocal = () =>
    window.location.hostname === 'local.portalbank.no' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '10.0.2.2';
